const DEFAULTS = {
  emptyMessage: 'No data available',
  searchPlaceholder: 'Search...',
  width: '700px',
  height: '600px',
  isLoading: false,
  hideSubmitButton: true,
  defaultSort: null,
  searchableFields: [],
};

const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
};

export { DEFAULTS, SORT_DIRECTION };
